export class CustomError extends Error {
    constructor(message, options) {
        super(message);
        const { code, duration, config } = options;
        this.code = code;
        this.duration = Array.isArray(duration) && duration.length > 0 ? duration : [];
        this.config = config;
    }
}
